var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{class:_vm.$vuetify.breakpoint.xs
      ? 'text-center pl-2 pr-2'
      : 'text-center pl-10 pr-10'},[[_c('v-card-title')],_c('v-row',{staticClass:"fullwidth pl-3 pr-3"},[_vm._v(" No access "+_vm._s(this.$route.params.component)+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }